import React,{useState,useEffect} from 'react'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';

function MerCheckbox(props) {
     const [checkedState, setCheckedState] = useState(props.info.options.map(option => {
        return (props.info.value.includes(option) ? true : false)
     }))

      const handleChange = (position) => {
      const updatedCheckedState = checkedState.map((item, index) =>
        index === position ? !item : item
      );
        
      setCheckedState(updatedCheckedState);
    };

    useEffect(() => {
        props.handleChange(props.info.id,props.info.options.filter((option,index) => checkedState[index]),props.info?._id)
    },[checkedState]);

    return (
    <FormControl>
      <div style={{display:'flex',justifyContent:'space-between', alignItems:'center' ,marginTop:2 ,marginBottom:2}}>
      <FormLabel required={props.info.mandatory} 
            sx={{'& .MuiFormLabel-asterisk': {
                color: 'red', fontSize: '30px'
            },
            color:'black',
            maxWidth:'50%',
            fontWeight:'bold'}}>{props.info.question_text}</FormLabel>
      <FormGroup
        row
        >
          {
            props.info.options.map((option,index) => {
                return(
                    <FormControlLabel key={index} sx={{color:'black'}} checked={checkedState[index]} onChange={()=>handleChange(index)} control={<Checkbox/>} label={option} name={option} disabled={!props.abled}/>
                );
            })
          }
          
      </FormGroup>
      </div>
    </FormControl>
  )
}

export default MerCheckbox
